module.exports = __webpack_public_path__ + "img/banner_make.5596a24b.jpg";